import { useContext } from "react";
import { DataContext } from "../../../store/data-context";
import styles from "./Section4.module.css";
import Button from "../../UI/Button";
const Section4 = () => {
  const { section4Image } =
    useContext(DataContext);

  return (
    <section
      className={styles["main-section__4"]}
      style={{
        backgroundImage: `url(${section4Image})`,
      }}
    >
      <h2>NEED AN APPOINTMENT FOR HELP?</h2>
      <p>
        Lorem ipsum dolor sit amet consectetur
        adipisicing elit. Ullam nostrum totam
        voluptate quis fugiat necessitatibus quasi
        commodi repellendus voluptas suscipit.
      </p>
      <Button>CONTACT NOW</Button>
    </section>
  );
};

export default Section4;
